var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 319,
    height: 181,
    viewBox: "0 0 319 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6563_2136)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -15,
    width: 344,
    height: 181,
    fill: "#6E00FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 140.5,
    r: 80.5,
    fill: "url(#paint0_radial_6563_2136)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 153.5,
    r: 62.5,
    fill: "url(#paint1_linear_6563_2136)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 159,
    r: 43,
    fill: "url(#paint2_linear_6563_2136)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_6563_2136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-15.7962 -102.518C42.0511 -159.088 134.804 -158.051 191.373 -100.204C247.942 -42.3568 246.906 50.3961 189.059 106.965C131.212 163.534 16.6064 211.175 -18.1105 104.651C-52.8273 -1.87351 17.608 31.0808 -59.6169 -6.37834C-136.842 -43.8374 -42.9276 -75.9865 -15.7962 -102.518Z",
    fill: "url(#paint3_linear_6563_2136)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_6563_2136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.204 -129.518C321.051 -186.088 413.804 -185.051 470.373 -127.204C526.942 -69.3568 525.906 23.3961 468.059 79.9653C410.212 136.534 295.606 184.175 260.89 77.6509C226.173 -28.8735 296.608 4.08077 219.383 -33.3783C142.158 -70.8374 236.072 -102.987 263.204 -129.518Z",
    fill: "url(#paint4_linear_6563_2136)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_6563_2136",
    x: -176.457,
    y: -231.277,
    width: 496.588,
    height: 486.381,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 43.5,
    result: "effect1_foregroundBlur_6563_2136"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_6563_2136",
    x: 102.543,
    y: -258.277,
    width: 496.588,
    height: 486.381,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 43.5,
    result: "effect1_foregroundBlur_6563_2136"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_6563_2136",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.5 140.5) rotate(-44.4791) scale(77.785)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.510125,
    stopColor: "#611CFE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C1CFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6563_2136",
    x1: 75,
    y1: 106,
    x2: 40,
    y2: 144.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8834FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8834FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6563_2136",
    x1: 52,
    y1: 126,
    x2: 20.5,
    y2: 166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C343FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A443FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6563_2136",
    x1: -46.1571,
    y1: 27.2413,
    x2: 126.311,
    y2: 8.68938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C343FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A443FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6563_2136",
    x1: 232.843,
    y1: 0.241278,
    x2: 405.311,
    y2: -18.3106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C343FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A443FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6563_2136"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 319,
    height: 181,
    rx: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletCard);
export default __webpack_public_path__ + "static/media/walletCard.ef072b183070ad25c93c3690d454183f.svg";
export { ForwardRef as ReactComponent };